import axios from 'axios'
import config from '../../../config'

let Hba1cApi = {
  putHba1cTracking(model) {
    return axios.put(config.apiUrl + 'tracking/hba1c/', model);
  },
  postHba1cTracking(model) {
    return axios.post(config.apiUrl + 'tracking/hba1c/', model)
  },
  /**
   *
   * @param page
   * @param page_size
   * @returns {AxiosPromise}
   */
  getHbA1cTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/hba1c/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  /**
   * @param id
   */
  deleteHbA1cReading(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/hba1c/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
};

export default Hba1cApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/HbA1c/index.js